import { IconProps } from '../Icons.type'

export function ExitIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5205_24619)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.99996 1.83268C1.95576 1.83268 1.91336 1.85024 1.88211 1.8815C1.85085 1.91275 1.83329 1.95515 1.83329 1.99935V17.9994C1.83329 18.0436 1.85085 18.0859 1.88211 18.1172C1.91336 18.1485 1.95575 18.166 1.99996 18.166H11C11.0442 18.166 11.0866 18.1485 11.1178 18.1172C11.1491 18.0859 11.1666 18.0436 11.1666 17.9994V14.1534C11.1666 13.6931 11.5397 13.32 12 13.32C12.4602 13.32 12.8333 13.6931 12.8333 14.1534V17.9994C12.8333 18.4856 12.6401 18.9519 12.2963 19.2957C11.9525 19.6395 11.4862 19.8327 11 19.8327H1.99996C1.51373 19.8327 1.04741 19.6395 0.703597 19.2957C0.35978 18.9519 0.166626 18.4856 0.166626 17.9994V1.99935C0.166626 1.51312 0.35978 1.0468 0.703597 0.702987C1.04741 0.35917 1.51373 0.166016 1.99996 0.166016H11C11.4862 0.166016 11.9525 0.35917 12.2963 0.702987C12.6401 1.0468 12.8333 1.51312 12.8333 1.99935V5.84535C12.8333 6.30559 12.4602 6.67868 12 6.67868C11.5397 6.67868 11.1666 6.30559 11.1666 5.84535V1.99935C11.1666 1.95515 11.1491 1.91275 11.1178 1.8815C11.0866 1.85024 11.0442 1.83268 11 1.83268H1.99996Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.16663 9.99935C6.16663 9.53911 6.53972 9.16602 6.99996 9.16602H19C19.4602 9.16602 19.8333 9.53911 19.8333 9.99935C19.8333 10.4596 19.4602 10.8327 19 10.8327H6.99996C6.53972 10.8327 6.16663 10.4596 6.16663 9.99935Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4107 6.41009C15.7361 6.08466 16.2638 6.08466 16.5892 6.41009L19.5892 9.41009C19.9147 9.73553 19.9147 10.2632 19.5892 10.5886L16.5892 13.5886C16.2638 13.914 15.7361 13.914 15.4107 13.5886C15.0853 13.2632 15.0853 12.7355 15.4107 12.4101L17.8214 9.99935L15.4107 7.5886C15.0853 7.26317 15.0853 6.73553 15.4107 6.41009Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_5205_24619">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
